
<template>
  <div class="layout">
      <div style="background-color: #2196F3; border-top: 1px solid black; border-left: 1px solid black; border-right: 1px solid black" class="bg-title">
        <h3 style="margin: 0; color: #fff;text-align: center; padding: 5px 0px 5px 0px;">THƯ XÁC NHẬN ĐẶT PHÒNG</h3>
      </div>
      <div style="border-top: 1px solid black; border-left: 1px solid black; border-right: 1px solid black;padding-left: 4px;">
        <span style="display: block;">Cảm ơn Quý khách đã chọn sử dụng dịch vụ tại Republic Plaza Serviced Apartment</span>
        <span>Chúng tôi xin xác nhận đặt phòng theo yêu cầu của Quý khách như sau:</span>
      </div>
      <table style="width:100%;">
        <!-- Mã đặt phòng -->
        <tr>
        <th>Mã đặt phòng:</th>
        <td colspan="7">{{apartment_booking_detail.booking_code}}</td>
        </tr>
        <!-- Tên khách hàng -->
        <tr>
        <th>Tên khách hàng:</th>
        <td colspan="7">{{apartment_booking_detail.booking_person_name}}</td>
        </tr>
        <!-- Điện thoại và Email -->
        <tr>
        <th colspan="1">Điện thoại:</th>
        <th colspan="3">{{apartment_booking_detail.booking_person_phone}}</th>
        <th colspan="1">Email:</th>
        <th colspan="3">{{apartment_booking_detail.booking_person_email}}</th>
        </tr>
        <!-- Số lượng khách -->
        <tr>
        <th colspan="1">Số lượng khách:</th>
        <th colspan="3">Người lớn: <span style="font-weight: normal;">{{max_adults}} người / phòng</span></th>
        <th colspan="1">Trẻ em (tuổi):</th>
        <th colspan="3" style="font-weight: normal;"> {{max_childs}} bé / phòng (dưới 6 tuổi)</th>
        </tr>
        <!-- Giá phòng -->
        <tr>
        <th rowspan="4">Giá phòng:</th>
        </tr>
        <tr>
            <td>Loại phòng</td>
            <td>Từ ngày</td>
            <td>Đến ngày</td>
            <td>Đơn giá/đêm</td>
            <td>Số đêm</td>
            <td>Số lượng căn</td>
            <td>Thành tiền</td>
        </tr>
        <tr>
            <td>{{apartment.bedroom_count}} phòng ngủ</td>
            <td>{{checkin_datetime}}</td>
            <td>{{checkout_datetime}}</td>
            <td style="text-align: right">{{amount_with_discount}}</td>
            <td style="text-align: center">{{number_of_days}}</td>
            <td style="text-align: center">{{apartment.bedroom_count}}</td>
            <td style="text-align: right">{{total_amount_with_discount}}</td>
        </tr>
        <tr>
        <td style="text-align: right;" colspan="6">Tổng cộng (đã bao gồm thuế và phí nếu có)</td>
        <td style="text-align: right" colspan="1">{{total_amount_with_discount_with_other_fee}}</td>
        </tr>
        <!-- Giá bao gồm -->
        <!-- <tr>
        <th :rowspan="e_w_included && service_other_detail != null && service_other_detail != '' ? 3 : 2">Giá bao gồm</th>
        </tr>
        <tr v-if="e_w_included && service_other_detail != null && service_other_detail != ''">
        <td colspan="7">{{service_other_detail}}</td>
        </tr>
        <tr v-if="!e_w_included && (service_other_detail == null || service_other_detail == '')">
        <td colspan="7">...</td>
        </tr>
        <tr v-if="!e_w_included && service_other_detail != null && service_other_detail != ''">
        <td colspan="7">{{service_other_detail}}</td>
        </tr>
        <tr v-if="e_w_included">
        <td colspan="7">Chi phí điện nước – Tính theo thực tế sử dụng</td>
        </tr> -->
        <tr>
            <th :rowspan="e_w_included ? 7 : 6">Giá bao gồm</th>
        </tr>
        <tr>
        <td colspan="7">Dọn phòng 3 lần / tuần</td>
        </tr>
        <tr>
        <td colspan="7">Thay chăn drap 1 lần / tuần	</td>
        </tr>
        <tr>
        <td colspan="7">Internet tốc độ cao trong phòng và các khu vực công cộng</td>
        </tr>
        <tr>
        <td colspan="7">Tiện ích Tivi thông minh tại phòng</td>
        </tr>
        <tr>
        <td colspan="7">Sử dụng hồ bơi, trung tâm thể dục thẩm mỹ</td>
        </tr>
        <tr v-if="e_w_included">
        <td colspan="7">Chi phí điện nước</td>
        </tr>
        <!-- Giá chưa bao gồm -->
        <tr>
        <th :rowspan="getRowSpan()">Giá chưa bao gồm</th>
        </tr>
        <tr v-if="service_other_detail != null && service_other_detail != ''">
        <td colspan="7">{{service_other_detail}}</td>
        </tr>
        <tr v-if="!e_w_included">
        <td colspan="7">Chi phí điện nước – Tính theo thực tế sử dụng</td>
        </tr>
        <tr>
        <td colspan="7">Dịch vụ ăn sáng, đưa đón sân bay, dịch vụ khác…</td>
        </tr>
        <!-- Thanh toán -->
        <tr>
        <th rowspan="5">Thanh toán</th>
        </tr>
        <tr>
        <td colspan="7">
            (1) Đặt cọc giữ chỗ số tiền: {{amount_reservation}} VNĐ (số tiền đặt cọc giữ chỗ sẽ được hoàn trả trong vòng 5 ngày làm việc sau khi cấn trừ các chi phí phát sinh nếu có) <br>
            (2) Số tiền cần thanh toán trước: {{payment_inadvance_request}} VNĐ <br>
            (1)+(2) => <span style='font-weight:bold;'>Tổng số tiền khách cần thanh toán: {{total_amount_with_reservation}} VNĐ. Thanh toán trước ngày {{due_date}}</span>
            <!-- <br><br> -->
            <!-- <div style="font-style: italic;">
                (1) Deposit amount: VND {{amount_reservation}} (deposit will be refunded within 5 working days after deducting arise expenses (if any))<br>
                (2) Advance payment: VND {{payment_inadvance_request}}<br>
                (1)+(2) => <span style='font-weight:bold;'>The total amount payable is VND {{total_amount_with_reservation}}. Payment must be paid before {{due_date}}</span>
            </div> -->
            <!-- (1) Tiền đặt cọc giữ chỗ: {{amount_reservation}}VNĐ (số tiền đặt cọc giữ chỗ sẽ được hoàn trả trong vòng 5 ngày làm việc sau khi cấn trừ các chi phí phát sinh nếu có) <br>
            (2) Tổng tiền phòng: {{total_amount_with_discount_with_other_fee}} VNĐ. Thanh toán trước ngày {{due_date}} <br>
            <span style="font-weight: bold;">(1)+(2) => Tổng số tiền khách cần thanh toán: {{total_amount_with_reservation}} VNĐ</span> -->
        </td>
        </tr>
        <tr>
        <td colspan="7">Các chi phí phát sinh khác (nếu có):  thanh toán tại quầy Lễ tân</td>
        </tr>
        <tr>
        <td colspan="7">Trường hợp Quý khách cần xuất hóa đơn, vui lòng thông báo với Bộ phận Đặt phòng bằng email hoặc thông báo với Lễ tân trước khi trả phòng</td>
        </tr>
        <tr>
        <td colspan="7">
            <div>
                <div>
                    <div style="width: 25%; display: inline-block;">
                        <span>Đơn vị thụ hưởng: </span>
                    </div>
                    <div style="display: inline-block;">
                        <span>{{banktransfer.bank_account_name}}</span>
                    </div>
                </div>
                <div>
                    <div style="width: 25%; display: inline-block;">
                        <span>Tài khoản: </span>
                    </div>
                    <div style="display: inline-block;">
                        <span>{{banktransfer.bank_account_no}}</span>
                    </div>
                </div>
                <div>
                    <div style="width: 25%; display: inline-block;">
                        <span>Ngân hàng: </span>
                    </div>
                    <div style="display: inline-block;">
                        <span>{{banktransfer.bank_code && banktransfer.bank_code.bank_code}} - {{banktransfer.bank_other_details}}</span>
                    </div>
                </div>
            </div>
        </td>
        </tr>
        <!-- Chính sách hủy -->
        <tr>
        <th>Chính sách hủy</th>
        <td colspan="7">Giá khuyến mãi trên không áp dụng cho việc hủy phòng và hoàn tiền</td>
        </tr>
        <!-- Thời gian nhận phòng và trả phòng -->
        <tr>
        <th>Thời gian nhận phòng và trả phòng</th>
        <td colspan="7">Thời gian nhận phòng: 02:00PM và thời gian trả phòng 12:00PM.</td>
        </tr>
        <!-- Quy định chung -->
        <tr>
        <th rowspan="3">Quy định chung</th>
        </tr>
        <tr>
        <td colspan="7">Trường hợp quý khách muốn đặt bữa sáng mang theo, vui lòng thông báo với Lễ tân trước 21:00 tối ngày hôm trước.</td>
        </tr>
        <tr>
        <td colspan="7">Vật nuôi sẽ không được phép mang vào Tòa nhà</td>
        </tr>
      </table>
        <!-- Support hotline -->
        <div>
            <p>Nếu Quý khách cần bất kỳ sự hỗ trợ hoặc thông tin bổ sung nào, xin vui lòng liên hệ với bộ phận Đặt phòng qua email: booking@republicplaza.vn. Rất hân hạnh được chào đón Quý khách đến với <span style="font-weight: bold"> Republic Plaza Serviced Apartment. </span>
            </p>
        </div>
		<!-- footer -->
		<div>
			<p>Trân trọng cảm ơn</p>
		</div>
		<div>
			<div v-if="projectLogo" style="float: left;">
				<img width="100px" height="80px;" :src="projectLogo">
			</div>
			<div style="margin-left: 30px;">
				<span style="display: block;">{{project_detail.address}}</span>
				<span style="display: block;">E: {{project_detail.email}}</span>
				<span style="display: block;">W: {{project_detail.website}}</span>
				<span style="display: block;">Republic Plaza Serviced Apartment – Booking Confirmation</span>
			</div>
      </div>
        <div class="row bg-button">
            <form class="form-horizontal">
                <div>
                    <button
                        id="cmdPrintPdf"
                        type="button"
                        class="btn btn-labeled btn-warning pull-right"
                        @click="printPdf"
                        style="margin-right: 5px;"
                    >
                        <span class="btn-label">
                            <i class="glyphicon glyphicon-print"></i>
                        </span>
                        {{$t('common.printPdf')}}
                    </button>
                </div>
            </form>
        </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment'
import utils from '@/lib/utils'

export default {
  name: "ConfirmedApartmentBookingPdf",
  data() {
    return {
        projectLogo: null,
        booking_data: [],
        apartment_booking_detail: [],
        project_detail: [],
        checkin_datetime: '',
        checkout_datetime: '',
        banktransfer: '',
        number_of_days: 0,
        apartment: {
            id: 0,
            apartment_code: "",
            size: "",
            bathroom_count: 0,
            bedroom_count: 0,
            room_count: 0,
            electric_value: 0,
            water_value: 0
        },
        amount: 0,
        amount_with_discount: 0,
        total_amount_with_discount: 0,
        total_amount_with_discount_with_other_fee: 0,
        e_w_included: false,
        service_other_detail: "",
        total_amount_with_reservation: 0,
        amount_reservation: 0,
        due_date: '',
        vat: 0,
        max_adults: 0,
        max_childs: 0,
        payment_inadvance_request: 0
    };
  },

  watch: {
  },
  computed: {
    ...mapGetters([
    ])
  },

  methods: {
    ...mapActions([
        "GET_BOOKING_DETAIL",
        "GET_BOOKING_APARTMENT_DETAIL",
        "GET_APARTMENT_DETAIL",
        "GET_ROOM_POLICY_WITH_BED_ROOM"
    ]),
    getRowSpan() {
        if (!this.e_w_included && this.service_other_detail != '' && this.service_other_detail != null) {
            return 4
        } else if (!this.e_w_included && (this.service_other_detail == '' || this.service_other_detail == null)) {
            return 3
        } else if (this.e_w_included && (this.service_other_detail != '' && this.service_other_detail != null)) {
            return 3
        } else {
            return 2
        }
    },
    printPdf: function () {
        document.getElementById("cmdPrintPdf").style.display = "none";
        window.print();
        document.getElementById("cmdPrintPdf").style.display = "";
    }
  },
  mounted() {
    this.projectLogo = sessionStorage.getItem('projectLogo')
    let booking_id = parseInt(this.$route.params.id)
    if (booking_id != 0) {
        this.GET_BOOKING_DETAIL({id: booking_id}).then(
            function(res){
                this.booking_data = res.data
                const filter = {
                    id: booking_id,
                    params: {
                        apartment: this.booking_data.apartment_booking_detail.apartment_mapping_with_booking_ids[0].apartment
                    }
                }
                this.GET_BOOKING_APARTMENT_DETAIL(filter).then(
                    function(res) {
                        let data = res
                        for (let i = 0, size = data.package_template[0].package_elements.length; i < size; i++) {
                            let package_template_data = data.package_template[0].package_elements[i]
                            if (package_template_data.service_details.feegroup == 1) {
                                this.vat = package_template_data.service_details.vat
                            }
                            let tax =  Math.round(Number(utils.formatInteger(this.total_amount_with_discount).toString()  - this.apartment_booking_detail.discount) * this.vat / 100)
                            this.total_amount_with_discount_with_other_fee = utils.formatNumber((Math.round(utils.formatInteger(this.total_amount_with_discount.toString())) + tax) - this.apartment_booking_detail.discount)
                            // Total amount with reservation
                            //this.amount_reservation = utils.formatNumber(Math.round(utils.formatInteger(this.total_amount_with_discount_with_other_fee.toString()) / 2))
                            //this.amount_reservation = utils.formatNumber(Math.round(utils.formatInteger(n.toString())))
                            //this.total_amount_with_reservation = utils.formatNumber(Number(utils.formatInteger(this.total_amount_with_discount_with_other_fee.toString())) + Number(utils.formatInteger(this.amount_reservation.toString())))

                            this.amount_reservation = utils.formatNumber(Math.round(utils.formatInteger(data.deposit_request.toString())))

                            this.payment_inadvance_request = utils.formatNumber(Math.round(utils.formatInteger(data.payment_inadvance_request.toString())))

                            this.total_amount_with_reservation = utils.formatNumber(Number(utils.formatInteger(this.payment_inadvance_request.toString())) + Number(utils.formatInteger(this.amount_reservation.toString())))
                        }
                    }.bind(this)
                )
                // Apartment booking detail
                this.apartment_booking_detail = this.booking_data.apartment_booking_detail
                // Project detail
                this.project_detail = this.booking_data.project_detail
                // Project banktransfer
                this.banktransfer = this.project_detail.banktransfer
                // Check-in date time
                this.checkin_datetime = utils.formatSqlDate(this.apartment_booking_detail.checkin_datetime, null, 'DD/MM/YYYY')
                // Check-out date time
                this.checkout_datetime = utils.formatSqlDate(this.apartment_booking_detail.checkout_datetime, null, 'DD/MM/YYYY')
                // Change format to count number of days
                let checkin = utils.formatSqlDate(this.checkin_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
                let checkout = utils.formatSqlDate(this.checkout_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
                // Number of days
                this.number_of_days = utils.datediff(checkin, checkout) == 'NaN' ? 0 : utils.datediff(checkin, checkout)
                // Due date
                this.due_date = moment(this.apartment_booking_detail.deposit_deadline)
                this.due_date = utils.formatSqlDate(this.due_date, null, "DD/MM/YYYY")
                // Booking room rate daily discount
                //let booking_room_rate_daily_discount = Math.round(this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].booking_room_rate_daily * this.apartment_booking_detail.sale_off / 100)
                // Booking room rate daily with discount
                //this.amount_with_discount = utils.formatNumber(this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].booking_room_rate_daily - booking_room_rate_daily_discount)
                // Booking room rate
                let booking_room_rate = this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].booking_room_rate
                let sale_off = this.apartment_booking_detail.sale_off
                let booking_room_rate_discount = booking_room_rate * (1 - sale_off / 100)
                // Booking rooom rate discount amount
                this.amount_with_discount = utils.formatNumber(Math.round(booking_room_rate_discount / (this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].payment_duration_factor == 1 ? 30 : (this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].payment_duration_factor == 2 ? 7 : 1))))
                // Apartment id
                let apartment_id = this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].apartment
                // Total booking room rate with discount
                //this.total_amount_with_discount = utils.formatNumber((utils.formatInteger(this.amount_with_discount.toString()) * this.number_of_days))
                this.total_amount_with_discount = utils.formatNumber(Math.round(booking_room_rate_discount / (this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].payment_duration_factor == 1 ? 30 : (this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].payment_duration_factor == 2 ? 7 : 1)) * this.number_of_days))
                // Tax
                let other_fee_vat = Math.round(this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].other_fee * this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].other_vat / 100)
                // Other fee with tax
                this.other_fee_with_vat = this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].other_fee + other_fee_vat
                // Total amount with discount with other fee
                // this.total_amount_with_discount_with_other_fee = utils.formatNumber((Number(utils.formatInteger(this.total_amount_with_discount.toString())) + Number(utils.formatInteger(this.other_fee_with_vat.toString()))) - this.apartment_booking_detail.discount)
                this.e_w_included = this.apartment_booking_detail.ew_included
                // Service other detail
                this.service_other_detail = this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].other_details
                this.GET_APARTMENT_DETAIL({id: apartment_id}).then(
                    function(res) {
                        this.apartment.bedroom_count = res.bedroom_count
                        let data = {
                            params: {
                                bedrooms: [res.bedroom_count]
                            }
                        }
                        this.GET_ROOM_POLICY_WITH_BED_ROOM(data).then(
                            function(res) {
                                let data = res[0]
                                this.max_adults = data.max_adults
                                this.max_childs = data.max_childs
                            }.bind(this)
                        )
                    }.bind(this)
                )
            }.bind(this)
        )
    }
  },
  components: {
  }
};
</script>

<style scoped>
    @media print {
        .pagebreak { page-break-before: always; } /* page-break-after works, as well */
        .layout {
            width: 90% !important;
        }
        .bg-title {
            background-color: #2196F3 !important;
            color: white !important;
            -webkit-print-color-adjust: exact;
        }
        .bg-title h3 {
            color: white !important;
            -webkit-print-color-adjust: exact;
        }
        .bg-button {
            display: none;
        }
        .padding {
            margin-top: 40px;
        }
    }
    .layout {
        width: 70%;
        margin: auto;
        margin-top: 40px;
        margin-bottom: 40px;
    }
    body {
        font-family: 'Times New Roman'
    }
    table, th, td {
        border: 1px solid black;
        border-collapse: collapse;
    }
    th, td {
        padding: 5px;
        text-align: left;    
    }
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ConfirmedApartmentBookingPdf.vue